import { render } from "./PerfilUsuarioModal.vue?vue&type=template&id=b64782a0&scoped=true"
import script from "./PerfilUsuarioModal.vue?vue&type=script&lang=js"
export * from "./PerfilUsuarioModal.vue?vue&type=script&lang=js"

import "./PerfilUsuarioModal.vue?vue&type=style&index=0&id=b64782a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b64782a0"]])

export default __exports__